// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
import {
  legalServiceSchema,
  breadcrumbSchema,
} from '@/utils/schema';

// 启用路由
Vue.use(Router);

// 导入路由

// 首页
// import index from '../pages/home/index'

// 导出路由 
export default new Router({
    mode: 'history',
    routes: [
        {
            name: 'index',
            path: '',
            redirect: '/index',
            meta: {
                title: '湖南旷真律师事务所',
                description: '湖南旷真律师事务所（旷真）是国内领先的精益法律服务提供商，业务涵盖应收款管理、知识产权维权、婚姻家事、刑事辩护、债务重组、物业法律服务等领域，覆盖全国数十个城市。',
                keywords: '湖南旷真律师事务所,旷真,精益法律服务,应收款律师,知识产权维权,婚姻家事律师,刑事辩护律师',
                canonical: '/',
            }
        },
        {
            name: 'index',
            path: '/index',
            component: () =>
                import('@/pages/home/index'),
            meta: {
                title: '湖南旷真律师事务所',
                description: '湖南旷真律师事务所（旷真）是国内领先的精益法律服务提供商，业务涵盖应收款管理、知识产权维权、婚姻家事、刑事辩护、债务重组、物业法律服务等领域，覆盖全国数十个城市。',
                keywords: '湖南旷真律师事务所,旷真,精益法律服务,应收款律师,知识产权维权,婚姻家事律师,刑事辩护律师',
                canonical: '/index',
            }
        },
        // 关于旷真
        {
            name: 'about',
            path: '/about',
            component: () =>
                import('@/pages/about/index'),
            meta: {
                title: '关于旷真 | 湖南旷真律师事务所',
                description: '了解湖南旷真律师事务所：发展历程、组织架构、企业文化与旷真观点。旷真以精益法律服务为核心，覆盖全国数十个城市。',
                keywords: '关于旷真,旷真律师事务所,旷真简介,旷真文化,旷真架构,旷真观点',
                canonical: '/about',
                jsonLd: [breadcrumbSchema([
                    { name: '首页', url: '/' },
                    { name: '关于旷真', url: '/about' },
                ])],
            }
        },
        // 旷真知产
        {
            name: 'intellectualProperty',
            path: '/intellectualProperty',
            component: () =>
                import('@/pages/intellectualProperty/index'),
            meta: {
                title: '旷真知产 | 湖南旷真律师事务所',
                description: '旷真知产提供商标、版权、专利维权法律服务，采用全风险代理模式，零成本、全垫资、零风险，帮助企业快速肃清市场侵权行为。',
                keywords: '知识产权维权,商标维权,版权维权,专利维权,旷真知产,知识产权律师',
                canonical: '/intellectualProperty',
                jsonLd: [legalServiceSchema({
                    name: '旷真知产 · 知识产权维权法律服务',
                    description: '商标、版权、专利维权，全风险代理，零成本、全垫资、零风险。',
                    url: '/intellectualProperty',
                })],
            }
        },
        // 旷真应收款
        {
            name: 'business',
            path: '/business',
            component: () =>
                import('@/pages/business/index'),
            meta: {
                title: '旷真应收款 | 湖南旷真律师事务所',
                description: '旷真应收款管理开创国内法律服务产品化先河，聚焦建材等行业应收账款回收，全风险代理，累计帮助客户收回应收款900多亿元。',
                keywords: '应收款管理,应收账款回收,建材行业应收款,债权收购,旷真应收款',
                canonical: '/business',
                jsonLd: [legalServiceSchema({
                    name: '旷真应收款 · 应收账款管理法律服务',
                    description: '建材等行业应收账款管理与回收，全风险代理，法律服务产品化。',
                    url: '/business',
                })],
            }
        },
        // 旷真民生
        {
            name: 'ms',
            path: '/ms',
            component: () =>
                import('@/pages/ms/index'),
            meta: {
                title: '旷真民生 | 湖南旷真律师事务所',
                description: '旷真民生专注家事与刑事法律服务，涵盖婚姻家事、离婚争议、财产保护、刑事辩护、律师会见等领域，每年服务客户10万+。',
                keywords: '旷真民生,婚姻家事,离婚律师,刑事辩护,刑事会见,家事调解',
                canonical: '/ms',
                jsonLd: [legalServiceSchema({
                    name: '旷真民生 · 家事与刑事法律服务',
                    description: '家事、刑事精益化法律服务，多元化解决方案。',
                    url: '/ms',
                })],
            }
        },
        // 新闻动态
        {
            name: 'news',
            path: '/news',
            component: () =>
                import('@/pages/news/index'),
            meta: {
                title: '新闻动态 | 文章中心 | 湖南旷真律师事务所',
                description: '湖南旷真律师事务所新闻动态与文章中心，涵盖旷真观点、团队风采等专业法律资讯与解读。',
                keywords: '旷真新闻,旷真观点,法律资讯,团队风采,旷真律师事务所动态',
                canonical: '/news',
                jsonLd: [breadcrumbSchema([
                    { name: '首页', url: '/' },
                    { name: '新闻动态', url: '/news' },
                ])],
            }
        },
        // 加入旷真
        {
            name: 'joinUs',
            path: '/joinUs',
            component: () =>
                import('@/pages/joinUs/index'),
            meta: {
                title: '加入旷真 | 湖南旷真律师事务所',
                description: '加入湖南旷真律师事务所，了解旷真人才发展、薪酬福利与职业成长体系，成为精益法律服务团队的一员。',
                keywords: '加入旷真,旷真招聘,律师事务所招聘,律师职业发展',
                canonical: '/joinUs',
            }
        },
        // 联系我们
        {
            name: 'contactUs',
            path: '/contactUs',
            component: () =>
                import('@/pages/contactUs/index'),
            meta: {
                title: '联系我们 | 湖南旷真律师事务所',
                description: '联系湖南旷真律师事务所，总部位于长沙市芙蓉区解放西路188号国金中心T1号写字楼40层，电话0731-89802222。',
                keywords: '联系旷真,旷真律师事务所地址,旷真电话,法律咨询',
                canonical: '/contactUs',
                jsonLd: [breadcrumbSchema([
                    { name: '首页', url: '/' },
                    { name: '联系我们', url: '/contactUs' },
                ])],
            }
        },
        // 人才成长
        {
            name: 'talentGrowth',
            path: '/talentGrowth',
            component: () =>
                import('@/pages/joinUs/talentGrowth'),
            meta: {
                title: '文章中心 | 湖南旷真律师事务所',
                description: '湖南旷真律师事务所人才成长与文章中心，分享精益法律服务实践与律师职业发展内容。',
                keywords: '旷真人才成长,律师职业发展,法律职业',
                canonical: '/talentGrowth',
            }
        },
        // 新闻详情
        {
            name: 'newsMsg',
            path: '/newsMsg',
            component: () =>
                import('@/pages/news/newsMsg'),
            meta: {
                title: '新闻详情 | 湖南旷真律师事务所',
                description: '湖南旷真律师事务所专业法律文章与新闻详情。',
                keywords: '旷真,法律文章,新闻详情',
                canonical: '/newsMsg',
            }
        },
        // 新闻详情（路径式，用于预渲染与 SEO 收录）
        {
            name: 'newsMsgDetail',
            path: '/newsMsg/:id',
            component: () =>
                import('@/pages/news/newsMsg'),
            meta: {
                title: '新闻详情 | 湖南旷真律师事务所',
                description: '湖南旷真律师事务所专业法律文章与新闻详情。',
                keywords: '旷真,法律文章,新闻详情',
            }
        },
        // 应收款
        {
            name: 'receivables',
            path: '/receivables',
            component: () =>
                import('@/pages/business/receivables'),
            meta: {
                title: '应收款 | 湖南旷真律师事务所',
                description: '旷真应收款管理提供建材等行业应收账款回收法律服务，全风险代理，覆盖混凝土供应商、物资租赁商、贸易商等客户群体。',
                keywords: '应收款,应收账款回收,建材应收款,债权收购,旷真应收款',
                canonical: '/receivables',
                jsonLd: [legalServiceSchema({
                    name: '旷真应收款 · 应收账款管理法律服务',
                    description: '建材等行业应收账款管理与回收，全风险代理。',
                    url: '/receivables',
                })],
            }
        },
        // 婚姻家事
        {
            name: 'marriage',
            path: '/marriage',
            component: () =>
                import('@/pages/business/marriage'),
            meta: {
                title: '婚姻家事 | 湖南旷真律师事务所',
                description: '旷真婚姻家事法律服务涵盖婚前财产保护、婚内财产保护、离婚争议解决、子女抚养、继承纠纷等，家事调解率80%+。',
                keywords: '婚姻家事,离婚律师,婚前财产,子女抚养,继承纠纷,家事调解',
                canonical: '/marriage',
                jsonLd: [legalServiceSchema({
                    name: '旷真婚姻家事法律服务',
                    description: '婚前/婚内财产保护、离婚争议解决、子女抚养、继承纠纷等。',
                    url: '/marriage',
                })],
            }
        },
        // 刑事辩护
        {
            name: 'criminal',
            path: '/criminal',
            component: () =>
                import('@/pages/business/criminal'),
            meta: {
                title: '刑事辩护 | 湖南旷真律师事务所',
                description: '旷真刑事辩护法律服务涵盖刑事法律咨询、律师会见、刑事控告、刑事辩护、刑事再审等，取保候审、不起诉、缓刑等利好判决占比40%+。',
                keywords: '刑事辩护,刑事律师,律师会见,刑事控告,取保候审,刑事再审',
                canonical: '/criminal',
                jsonLd: [legalServiceSchema({
                    name: '旷真刑事辩护法律服务',
                    description: '刑事法律咨询、律师会见、刑事控告、刑事辩护、刑事再审等。',
                    url: '/criminal',
                })],
            }
        },
        // 物业法律服务
        {
            name: 'propertyLegalServices',
            path: '/propertyLegalServices',
            component: () =>
                import('@/pages/business/propertyLegalServices'),
            meta: {
                title: '物业法律服务 | 湖南旷真律师事务所',
                description: '旷真物业法律服务为物业企业提供法律顾问、物业费清收、合同审查、纠纷处理等精益法律服务。',
                keywords: '物业法律服务,物业法律顾问,物业费清收,物业纠纷',
                canonical: '/propertyLegalServices',
                jsonLd: [legalServiceSchema({
                    name: '旷真物业法律服务',
                    description: '物业法律顾问、物业费清收、合同审查、纠纷处理。',
                    url: '/propertyLegalServices',
                })],
            }
        },
        // 旷真案例（一级菜单，页内分类切换）
        {
            path: '/cases',
            redirect: '/cases/family',
        },
        // 案例详情：/cases/family/1521
        {
            name: 'caseDetail',
            path: '/cases/:type/:id',
            component: () =>
                import('@/pages/news/newsMsg'),
            meta: {
                title: '案例详情 | 湖南旷真律师事务所',
                description: '旷真案例详情，展示家事、刑事与应收款等领域法律服务实践。',
                keywords: '旷真案例,家事案例,刑事案例,应收款案例,湖南旷真律师事务所',
            }
        },
        {
            name: 'cases',
            path: '/cases/:type',
            component: () =>
                import('@/pages/cases/index'),
            meta: {
                title: '旷真案例 | 湖南旷真律师事务所',
                description: '旷真案例涵盖家事、刑事与应收款等领域法律服务实践，展示旷真律师办案成果。',
                keywords: '旷真案例,家事案例,刑事案例,应收款案例,湖南旷真律师事务所',
                canonical: '/cases',
            }
        },
        // 债务重组
        {
            name: 'debtRestructuring',
            path: '/debtRestructuring',
            component: () =>
                import('@/pages/business/debtRestructuring'),
            meta: {
                title: '债务重组 | 湖南旷真律师事务所',
                description: '旷真债务重组法律服务提供债务重组、债权处置、资产盘活等精益法律服务，帮助客户化解债务风险。',
                keywords: '债务重组,债权处置,债务化解,资产盘活,旷真',
                canonical: '/debtRestructuring',
                jsonLd: [legalServiceSchema({
                    name: '旷真债务重组法律服务',
                    description: '债务重组、债权处置、资产盘活等法律服务。',
                    url: '/debtRestructuring',
                })],
            }
        }
    ]
})